import { getSpacing as paletteGetSpacing } from '../theme/mui/palettes/utils';

export const important = (value: string) => {
  return `${value} !important`;
};

export const getSpacing = paletteGetSpacing;
